const LayoutGrid = ({ columns, rows, margin, children }) => {
	return <div className={`l-grid l-grid--${columns}-column l-grid--${rows}-row ${margin ? margin : ''}`}>{children}</div>;
};

export default LayoutGrid;
